@file:OptIn(InternalResourceApi::class)

package top.design_system.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/top.design_system.generated.resources/"

@delegate:ResourceContentHash(-1_850_150_458)
public val Res.drawable.Like: DrawableResource by lazy {
      DrawableResource("drawable:Like", setOf(
        ResourceItem(setOf(), "${MD}drawable/Like.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_203_611_010)
public val Res.drawable.ic_action_3_dot: DrawableResource by lazy {
      DrawableResource("drawable:ic_action_3_dot", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_action_3_dot.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-318_521_492)
public val Res.drawable.ic_alert_circle: DrawableResource by lazy {
      DrawableResource("drawable:ic_alert_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_alert_circle.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-784_573_848)
public val Res.drawable.ic_alert_warning: DrawableResource by lazy {
      DrawableResource("drawable:ic_alert_warning", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_alert_warning.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_103_479_233)
public val Res.drawable.ic_app_small: DrawableResource by lazy {
      DrawableResource("drawable:ic_app_small", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_app_small.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_450_982_326)
public val Res.drawable.ic_arrow_down: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_down.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_346_920_299)
public val Res.drawable.ic_arrow_left: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_left.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_002_205_960)
public val Res.drawable.ic_arrow_left_vector: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_left_vector", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_left_vector.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_406_236_386)
public val Res.drawable.ic_arrow_up: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_up.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(634_072_496)
public val Res.drawable.ic_block: DrawableResource by lazy {
      DrawableResource("drawable:ic_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_block.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_259_816_957)
public val Res.drawable.ic_check: DrawableResource by lazy {
      DrawableResource("drawable:ic_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(172_654_670)
public val Res.drawable.ic_checkbox_checked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkbox_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkbox_checked.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-422_267_843)
public val Res.drawable.ic_checkbox_unchecked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkbox_unchecked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkbox_unchecked.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(890_744_538)
public val Res.drawable.ic_client_action_catalog: DrawableResource by lazy {
      DrawableResource("drawable:ic_client_action_catalog", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_client_action_catalog.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(81_501_986)
public val Res.drawable.ic_client_action_phone: DrawableResource by lazy {
      DrawableResource("drawable:ic_client_action_phone", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_client_action_phone.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_036_652_466)
public val Res.drawable.ic_client_action_share: DrawableResource by lazy {
      DrawableResource("drawable:ic_client_action_share", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_client_action_share.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-138_369_190)
public val Res.drawable.ic_client_action_website: DrawableResource by lazy {
      DrawableResource("drawable:ic_client_action_website", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_client_action_website.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_066_567_710)
public val Res.drawable.ic_close: DrawableResource by lazy {
      DrawableResource("drawable:ic_close", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_close.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_076_707_667)
public val Res.drawable.ic_cost: DrawableResource by lazy {
      DrawableResource("drawable:ic_cost", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cost.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-868_112_088)
public val Res.drawable.ic_edit: DrawableResource by lazy {
      DrawableResource("drawable:ic_edit", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_edit.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(783_896_823)
public val Res.drawable.ic_email: DrawableResource by lazy {
      DrawableResource("drawable:ic_email", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_email.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(123_210_333)
public val Res.drawable.ic_file: DrawableResource by lazy {
      DrawableResource("drawable:ic_file", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_file.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_329_938_506)
public val Res.drawable.ic_filter: DrawableResource by lazy {
      DrawableResource("drawable:ic_filter", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_filter.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_181_051_735)
public val Res.drawable.ic_filter_sliders: DrawableResource by lazy {
      DrawableResource("drawable:ic_filter_sliders", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_filter_sliders.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_561_884_011)
public val Res.drawable.ic_heart: DrawableResource by lazy {
      DrawableResource("drawable:ic_heart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_heart.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_044_087_726)
public val Res.drawable.ic_heart_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_heart_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_heart_filled.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_850_150_458)
public val Res.drawable.ic_like: DrawableResource by lazy {
      DrawableResource("drawable:ic_like", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_like.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_946_223_320)
public val Res.drawable.ic_logo_transparent: DrawableResource by lazy {
      DrawableResource("drawable:ic_logo_transparent", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_logo_transparent.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_231_033_952)
public val Res.drawable.ic_nav_ai_moderation: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_ai_moderation", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_ai_moderation.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(213_620_300)
public val Res.drawable.ic_nav_business: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_business", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_business.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_279_745_002)
public val Res.drawable.ic_nav_dashboard: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_dashboard", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_dashboard.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-896_685_020)
public val Res.drawable.ic_nav_moderators: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_moderators", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_moderators.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(934_604_284)
public val Res.drawable.ic_nav_review: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_review", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_review.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_010_450_051)
public val Res.drawable.ic_nav_settings: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_settings", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_settings.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_855_799_304)
public val Res.drawable.ic_nav_users: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_users", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_users.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-768_941_031)
public val Res.drawable.ic_notification_bell: DrawableResource by lazy {
      DrawableResource("drawable:ic_notification_bell", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_notification_bell.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_425_225_087)
public val Res.drawable.ic_photo: DrawableResource by lazy {
      DrawableResource("drawable:ic_photo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_photo.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_665_921_993)
public val Res.drawable.ic_plus: DrawableResource by lazy {
      DrawableResource("drawable:ic_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_plus.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_077_880_015)
public val Res.drawable.ic_plus_circle: DrawableResource by lazy {
      DrawableResource("drawable:ic_plus_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_plus_circle.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(887_714_704)
public val Res.drawable.ic_profile: DrawableResource by lazy {
      DrawableResource("drawable:ic_profile", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_profile.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(659_867_181)
public val Res.drawable.ic_profile_fixed: DrawableResource by lazy {
      DrawableResource("drawable:ic_profile_fixed", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_profile_fixed.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_882_435_023)
public val Res.drawable.ic_profile_new: DrawableResource by lazy {
      DrawableResource("drawable:ic_profile_new", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_profile_new.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_512_172_764)
public val Res.drawable.ic_radio_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_radio_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_radio_selected.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(583_499_411)
public val Res.drawable.ic_radio_unselected: DrawableResource by lazy {
      DrawableResource("drawable:ic_radio_unselected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_radio_unselected.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_042_932_239)
public val Res.drawable.ic_rating_star_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_rating_star_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_rating_star_filled.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(86_234_951)
public val Res.drawable.ic_search: DrawableResource by lazy {
      DrawableResource("drawable:ic_search", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_search.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_680_768_523)
public val Res.drawable.ic_shield: DrawableResource by lazy {
      DrawableResource("drawable:ic_shield", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_shield.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-782_626_879)
public val Res.drawable.ic_tab_home: DrawableResource by lazy {
      DrawableResource("drawable:ic_tab_home", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tab_home.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(797_935_109)
public val Res.drawable.ic_tab_home_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_tab_home_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tab_home_filled.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_939_795_666)
public val Res.drawable.ic_tab_map: DrawableResource by lazy {
      DrawableResource("drawable:ic_tab_map", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tab_map.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_433_016_323)
public val Res.drawable.ic_tab_map_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_tab_map_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tab_map_filled.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_209_534_786)
public val Res.drawable.ic_tab_profile: DrawableResource by lazy {
      DrawableResource("drawable:ic_tab_profile", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tab_profile.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(451_823_497)
public val Res.drawable.ic_tab_profile_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_tab_profile_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tab_profile_filled.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(676_833_546)
public val Res.drawable.ic_tab_saved: DrawableResource by lazy {
      DrawableResource("drawable:ic_tab_saved", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tab_saved.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_044_087_726)
public val Res.drawable.ic_tab_saved_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_tab_saved_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tab_saved_filled.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-128_096_111)
public val Res.drawable.ic_tag: DrawableResource by lazy {
      DrawableResource("drawable:ic_tag", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tag.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-30_454_986)
public val Res.drawable.ic_unblock: DrawableResource by lazy {
      DrawableResource("drawable:ic_unblock", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_unblock.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_872_709_738)
public val Res.drawable.ic_upload: DrawableResource by lazy {
      DrawableResource("drawable:ic_upload", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_upload.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_500_019_641)
public val Res.drawable.ic_venue_gallery: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_gallery", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_gallery.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_126_299_468)
public val Res.drawable.ic_venue_gallery_upload: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_gallery_upload", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_gallery_upload.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(775_787_083)
public val Res.drawable.ic_venue_group_auto: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_auto", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_auto.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-207_865_813)
public val Res.drawable.ic_venue_group_beauty: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_beauty", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_beauty.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_737_004_910)
public val Res.drawable.ic_venue_group_business: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_business", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_business.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(393_063_609)
public val Res.drawable.ic_venue_group_education: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_education", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_education.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_285_070_950)
public val Res.drawable.ic_venue_group_entertainment: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_entertainment", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_entertainment.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_576_388_767)
public val Res.drawable.ic_venue_group_events: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_events", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_events.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(558_067_611)
public val Res.drawable.ic_venue_group_food: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_food", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_food.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_900_284_363)
public val Res.drawable.ic_venue_group_health: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_health", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_health.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_160_401_299)
public val Res.drawable.ic_venue_group_home: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_home", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_home.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-434_258_016)
public val Res.drawable.ic_venue_group_household: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_household", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_household.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-727_040_598)
public val Res.drawable.ic_venue_group_it_media: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_it_media", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_it_media.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(621_190_185)
public val Res.drawable.ic_venue_group_logistics: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_logistics", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_logistics.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-120_655_253)
public val Res.drawable.ic_venue_group_pets: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_pets", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_pets.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_212_342_722)
public val Res.drawable.ic_venue_group_shopping: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_shopping", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_shopping.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(554_567_565)
public val Res.drawable.ic_venue_group_travel: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_group_travel", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_group_travel.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-755_128_532)
public val Res.drawable.ic_venue_image_placeholder: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_image_placeholder", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_image_placeholder.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-832_130_704)
public val Res.drawable.ic_venue_location: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_location", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_location.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-946_755_581)
public val Res.drawable.ic_venue_main_info: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_main_info", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_main_info.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_481_617_496)
public val Res.drawable.ic_venue_moderator_assign: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_moderator_assign", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_moderator_assign.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(36_511_568)
public val Res.drawable.ic_venue_owner: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_owner", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_owner.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-832_130_704)
public val Res.drawable.ic_venue_schedule: DrawableResource by lazy {
      DrawableResource("drawable:ic_venue_schedule", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_venue_schedule.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_272_629_390)
public val Res.drawable.ic_view_venue: DrawableResource by lazy {
      DrawableResource("drawable:ic_view_venue", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_view_venue.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-710_703_189)
public val Res.drawable.img_logo_transparent: DrawableResource by lazy {
      DrawableResource("drawable:img_logo_transparent", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_logo_transparent.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-727_863_409)
public val Res.drawable.img_onboarding_discover: DrawableResource by lazy {
      DrawableResource("drawable:img_onboarding_discover", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_onboarding_discover.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(863_206_037)
public val Res.drawable.img_onboarding_filters_map: DrawableResource by lazy {
      DrawableResource("drawable:img_onboarding_filters_map", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_onboarding_filters_map.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_318_504_182)
public val Res.drawable.img_onboarding_reviews: DrawableResource by lazy {
      DrawableResource("drawable:img_onboarding_reviews", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_onboarding_reviews.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-45_616_846)
public val Res.drawable.img_onboarding_share: DrawableResource by lazy {
      DrawableResource("drawable:img_onboarding_share", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_onboarding_share.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_131_240_982)
public val Res.drawable.img_onboarding_start: DrawableResource by lazy {
      DrawableResource("drawable:img_onboarding_start", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_onboarding_start.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(126_403_484)
public val Res.drawable.img_sign_up_1: DrawableResource by lazy {
      DrawableResource("drawable:img_sign_up_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_sign_up_1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(56_398_449)
public val Res.drawable.img_sign_up_2: DrawableResource by lazy {
      DrawableResource("drawable:img_sign_up_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_sign_up_2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_131_942_579)
public val Res.drawable.img_sign_up_3: DrawableResource by lazy {
      DrawableResource("drawable:img_sign_up_3", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_sign_up_3.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("Like", Res.drawable.Like)
  map.put("ic_action_3_dot", Res.drawable.ic_action_3_dot)
  map.put("ic_alert_circle", Res.drawable.ic_alert_circle)
  map.put("ic_alert_warning", Res.drawable.ic_alert_warning)
  map.put("ic_app_small", Res.drawable.ic_app_small)
  map.put("ic_arrow_down", Res.drawable.ic_arrow_down)
  map.put("ic_arrow_left", Res.drawable.ic_arrow_left)
  map.put("ic_arrow_left_vector", Res.drawable.ic_arrow_left_vector)
  map.put("ic_arrow_up", Res.drawable.ic_arrow_up)
  map.put("ic_block", Res.drawable.ic_block)
  map.put("ic_check", Res.drawable.ic_check)
  map.put("ic_checkbox_checked", Res.drawable.ic_checkbox_checked)
  map.put("ic_checkbox_unchecked", Res.drawable.ic_checkbox_unchecked)
  map.put("ic_client_action_catalog", Res.drawable.ic_client_action_catalog)
  map.put("ic_client_action_phone", Res.drawable.ic_client_action_phone)
  map.put("ic_client_action_share", Res.drawable.ic_client_action_share)
  map.put("ic_client_action_website", Res.drawable.ic_client_action_website)
  map.put("ic_close", Res.drawable.ic_close)
  map.put("ic_cost", Res.drawable.ic_cost)
  map.put("ic_edit", Res.drawable.ic_edit)
  map.put("ic_email", Res.drawable.ic_email)
  map.put("ic_file", Res.drawable.ic_file)
  map.put("ic_filter", Res.drawable.ic_filter)
  map.put("ic_filter_sliders", Res.drawable.ic_filter_sliders)
  map.put("ic_heart", Res.drawable.ic_heart)
  map.put("ic_heart_filled", Res.drawable.ic_heart_filled)
  map.put("ic_like", Res.drawable.ic_like)
  map.put("ic_logo_transparent", Res.drawable.ic_logo_transparent)
  map.put("ic_nav_ai_moderation", Res.drawable.ic_nav_ai_moderation)
  map.put("ic_nav_business", Res.drawable.ic_nav_business)
  map.put("ic_nav_dashboard", Res.drawable.ic_nav_dashboard)
  map.put("ic_nav_moderators", Res.drawable.ic_nav_moderators)
  map.put("ic_nav_review", Res.drawable.ic_nav_review)
  map.put("ic_nav_settings", Res.drawable.ic_nav_settings)
  map.put("ic_nav_users", Res.drawable.ic_nav_users)
  map.put("ic_notification_bell", Res.drawable.ic_notification_bell)
  map.put("ic_photo", Res.drawable.ic_photo)
  map.put("ic_plus", Res.drawable.ic_plus)
  map.put("ic_plus_circle", Res.drawable.ic_plus_circle)
  map.put("ic_profile", Res.drawable.ic_profile)
  map.put("ic_profile_fixed", Res.drawable.ic_profile_fixed)
  map.put("ic_profile_new", Res.drawable.ic_profile_new)
  map.put("ic_radio_selected", Res.drawable.ic_radio_selected)
  map.put("ic_radio_unselected", Res.drawable.ic_radio_unselected)
  map.put("ic_rating_star_filled", Res.drawable.ic_rating_star_filled)
  map.put("ic_search", Res.drawable.ic_search)
  map.put("ic_shield", Res.drawable.ic_shield)
  map.put("ic_tab_home", Res.drawable.ic_tab_home)
  map.put("ic_tab_home_filled", Res.drawable.ic_tab_home_filled)
  map.put("ic_tab_map", Res.drawable.ic_tab_map)
  map.put("ic_tab_map_filled", Res.drawable.ic_tab_map_filled)
  map.put("ic_tab_profile", Res.drawable.ic_tab_profile)
  map.put("ic_tab_profile_filled", Res.drawable.ic_tab_profile_filled)
  map.put("ic_tab_saved", Res.drawable.ic_tab_saved)
  map.put("ic_tab_saved_filled", Res.drawable.ic_tab_saved_filled)
  map.put("ic_tag", Res.drawable.ic_tag)
  map.put("ic_unblock", Res.drawable.ic_unblock)
  map.put("ic_upload", Res.drawable.ic_upload)
  map.put("ic_venue_gallery", Res.drawable.ic_venue_gallery)
  map.put("ic_venue_gallery_upload", Res.drawable.ic_venue_gallery_upload)
  map.put("ic_venue_group_auto", Res.drawable.ic_venue_group_auto)
  map.put("ic_venue_group_beauty", Res.drawable.ic_venue_group_beauty)
  map.put("ic_venue_group_business", Res.drawable.ic_venue_group_business)
  map.put("ic_venue_group_education", Res.drawable.ic_venue_group_education)
  map.put("ic_venue_group_entertainment", Res.drawable.ic_venue_group_entertainment)
  map.put("ic_venue_group_events", Res.drawable.ic_venue_group_events)
  map.put("ic_venue_group_food", Res.drawable.ic_venue_group_food)
  map.put("ic_venue_group_health", Res.drawable.ic_venue_group_health)
  map.put("ic_venue_group_home", Res.drawable.ic_venue_group_home)
  map.put("ic_venue_group_household", Res.drawable.ic_venue_group_household)
  map.put("ic_venue_group_it_media", Res.drawable.ic_venue_group_it_media)
  map.put("ic_venue_group_logistics", Res.drawable.ic_venue_group_logistics)
  map.put("ic_venue_group_pets", Res.drawable.ic_venue_group_pets)
  map.put("ic_venue_group_shopping", Res.drawable.ic_venue_group_shopping)
  map.put("ic_venue_group_travel", Res.drawable.ic_venue_group_travel)
  map.put("ic_venue_image_placeholder", Res.drawable.ic_venue_image_placeholder)
  map.put("ic_venue_location", Res.drawable.ic_venue_location)
  map.put("ic_venue_main_info", Res.drawable.ic_venue_main_info)
  map.put("ic_venue_moderator_assign", Res.drawable.ic_venue_moderator_assign)
  map.put("ic_venue_owner", Res.drawable.ic_venue_owner)
  map.put("ic_venue_schedule", Res.drawable.ic_venue_schedule)
  map.put("ic_view_venue", Res.drawable.ic_view_venue)
  map.put("img_logo_transparent", Res.drawable.img_logo_transparent)
  map.put("img_onboarding_discover", Res.drawable.img_onboarding_discover)
  map.put("img_onboarding_filters_map", Res.drawable.img_onboarding_filters_map)
  map.put("img_onboarding_reviews", Res.drawable.img_onboarding_reviews)
  map.put("img_onboarding_share", Res.drawable.img_onboarding_share)
  map.put("img_onboarding_start", Res.drawable.img_onboarding_start)
  map.put("img_sign_up_1", Res.drawable.img_sign_up_1)
  map.put("img_sign_up_2", Res.drawable.img_sign_up_2)
  map.put("img_sign_up_3", Res.drawable.img_sign_up_3)
}
